import { marked } from 'marked'
import DOMPurify from 'dompurify'

// Configure marked options
marked.setOptions({
  breaks: true, // Convert \n to <br>
  gfm: true // GitHub Flavored Markdown
})

/**
 * Composable for parsing and sanitizing markdown content
 */
export function useMarkdown() {
  /**
   * Parse markdown to HTML and sanitize it to prevent XSS attacks
   */
  const parseMarkdown = (content: string): string => {
    try {
      // Parse markdown to HTML
      const html = marked.parse(content) as string

      // Sanitize HTML to prevent XSS
      const sanitized = DOMPurify.sanitize(html, {
        ALLOWED_TAGS: [
          'p', 'br', 'strong', 'em', 'u', 's', 'code', 'pre',
          'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
          'ul', 'ol', 'li',
          'blockquote',
          'a', 'img',
          'table', 'thead', 'tbody', 'tr', 'th', 'td',
          'hr',
          'del', 'ins', 'sub', 'sup',
          'div', 'span'
        ],
        ALLOWED_ATTR: ['href', 'title', 'target', 'rel', 'src', 'alt', 'class'],
        ALLOWED_URI_REGEXP: /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
      })

      return sanitized
    } catch (error) {
      console.error('[useMarkdown] Error parsing markdown:', error)
      // Return the original content if parsing fails
      return content
    }
  }

  return {
    parseMarkdown
  }
}
